import PropTypes from 'prop-types';
import * as ALOOMA from 'consts/alooma';
import { requestTagsBulkFulfill } from 'store/multiEdit/actions';
import useAction from 'hooks/useAction';
import ModalBodyTags from 'components/molecules/ModalBodyTags/ModalBodyTags';
import Modal from 'components/templates/Modal/Modal';

const ModalTagsFulfill = props => {
  const { closeModal } = props;
  const requestTagsBulkFulfillFunc = useAction(requestTagsBulkFulfill);

  return (
    <Modal source={ALOOMA.SOURCE_PAGES.TAGS_FULFILL} onClose={closeModal}>
      <ModalBodyTags
        title="app:markNumberItemsAsFullfilled"
        primaryButtonText="app:markAsFulfilled"
        onSubmit={requestTagsBulkFulfillFunc}
        {...props}
      />
    </Modal>
  );
};

ModalTagsFulfill.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ModalTagsFulfill;
